import React, { useState, useMemo } from 'react';
import { PropTypes } from 'prop-types';
import { useDispatch } from 'react-redux';
import { UnlockOutlined } from '@ant-design/icons';
import { Formik } from 'formik';
import { Form } from 'formik-antd';
import styled from 'styled-components';
import * as Yup from 'yup';
import { Col, Modal, Row, message as toaster } from 'antd';
import { Box, Button, CustomInput, Flex, FormInput } from 'atoms';
import { updateResetPassword } from 'store/commonSlice';

const ResetButton = styled(Button)`
	background: transparent;
	color: #1890ff;
	border-radius: 4px;
`;

export default function ResetBtn({ username }) {
	const dispatch = useDispatch();

	const [modalOpen, setModalOpen] = useState(false);

	const FormSchema = Yup.object({
		new_password: Yup.string()
			.label('New Password')
			.min(6)
			.max(16)
			.required()
			.matches(
				/^[a-zA-Z0-9@#$]*$/,
				'Password should be Alpha-numeric, # (hash), @ (at) and $ (dollar) allowed'
			),
		confirm_new_password: Yup.string()
			.label('Confirm Password')
			.required()
			.oneOf([Yup.ref('new_password'), null], 'Passwords must match'),
	});

	const initialValues = useMemo(
		() => ({
			username,
			new_password: undefined,
			confirm_new_password: undefined,
		}),
		[username]
	);

	const handleSubmit = (values, { setErrors, setSubmitting }) => {
		console.log('values', values);
		console.log('setErrors', setErrors);
		console.log('setSubmitting', setSubmitting);

		const data = {
			username,
			new_password: values?.new_password,
			confirm_new_password: values?.confirm_new_password,
		};
		console.log('data', data);

		dispatch(updateResetPassword(data)).then(() => {
			toaster.success('Password updated successfully');
			// setTimeout(() => {
			// 	window.location.reload();
			// }, 500);
		});

		setModalOpen(false);
	};

	return (
		<Flex justifyContent="flex-end">
			<ResetButton onClick={() => setModalOpen(true)}>
				<UnlockOutlined /> Reset Password
			</ResetButton>
			{modalOpen && (
				<Modal
					title="Reset Password"
					centered
					open={modalOpen}
					footer={null}
					onCancel={() => setModalOpen(false)}
				>
					<Formik
						initialValues={initialValues}
						validationSchema={FormSchema}
						onSubmit={handleSubmit}
						enableReinitialize
					>
						<Form>
							<Box>
								<Row>
									<Col lg={12}>
										<FormInput name="username" label="Username">
											<CustomInput
												name="username"
												value={username}
												disabled
											/>
										</FormInput>
										{/* <SpanUserName> Username: {username} </SpanUserName>{' '} */}
									</Col>
								</Row>
								<Row gutter={16} justify="space-between">
									<Col lg={12}>
										<FormInput name="new_password" label="New password *">
											<CustomInput name="new_password" />
										</FormInput>
									</Col>
									<Col lg={12}>
										<FormInput
											name="confirm_new_password"
											label="Confirm password*"
										>
											<CustomInput name="confirm_new_password" />
										</FormInput>
									</Col>
								</Row>
							</Box>
							<Box textAlign="right" padding="1.5rem">
								<Button borderRadius="4px" backgroundColor="#18405d" type="submit">
									Submit
								</Button>
							</Box>
						</Form>
					</Formik>
				</Modal>
			)}
		</Flex>
	);
}

ResetBtn.propTypes = {
	username: PropTypes.string,
};
